// extracted by mini-css-extract-plugin
export default {"body":"AddWarehouseModal_body__iW5yO","actions":"AddWarehouseModal_actions__MKD+J"};